import React from "react";
import { Select, SelectProps } from "@mui/material";

function DSSelect<T = unknown>(props: SelectProps<T>) {
  return <Select {...props} />;
}

export default DSSelect;
